import { getLocalStorage } from "../utils";
import axios, { Method } from "axios";

require("dotenv").config();
const GET: Method = "GET";
const POST: Method = "POST";
const PUT: Method = "PUT";

const endpoint = "https://www.jcdinteractiveads.com";

const apis = {
  getCode: {
    url: endpoint + "/api/code",
    method: GET,
  },
  question: {
    url: endpoint + "/api/question",
    method: POST,
  },
  coupons: {
    url: endpoint + "/api/list",
    method: GET,
  },
  login: {
    url: endpoint + "/api/login",
    method: POST,
  },
  register: {
    url: endpoint + "/api/register",
    method: POST,
  },
  verify: {
    url: endpoint + "/api/verify",
    method: PUT,
  },

  submitScore: {
    url: endpoint + "/api/score",
    method: POST,
  },
};

const callApi = (
  method: Method,
  url: string,
  params: any = null,
  header = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getLocalStorage("token");
      axios({
        method: method,
        url: url,
        data: params,
        headers: {
          ...header,
          authentication: token || null,
        },
      })
        .then((response) => {
          resolve(response ? response.data : null);
        })
        .catch(async (error) => {
          const { data } = error.response || {};
          reject(data);
        });
    } catch (e) {
      reject({ code: 500, message: "Please try again later", data: null });
    }
  });
};

export { callApi, apis };
